// extracted by mini-css-extract-plugin
export var actionButton = "_o7-0";
export var actionMenuContainer = "_o7-i";
export var bubble = "_o7-2";
export var bubbleActionMenu = "_o7-j";
export var bubbleContext = "_o7-6";
export var bubbleItems = "_o7-7";
export var customer = "_o7-3";
export var divider = "_o7-8";
export var fileList = "_o7-9";
export var hiddenComment = "_o7-o";
export var infoAbove = "_o7-a";
export var internal = "_o7-4";
export var lightActionButton = "_o7-1";
export var link = "_o7-b";
export var merchant = "_o7-5";
export var message = "_o7-c";
export var profilePicture = "_o7-e";
export var quillToolbarContainer = "_o7-f";
export var senderDate = "_o7-g";
export var senderDateCustomer = "_o7-h";
export var senderName = "_o7-d";
export var time = "_o7-k";
export var uploadedImage = "_o7-l";
export var username = "_o7-m";
export var xsmall = "_o7-n";